import { render, staticRenderFns } from "./StaticPagesManagement.vue?vue&type=template&id=438bc972&"
import script from "./StaticPagesManagement.vue?vue&type=script&lang=js&"
export * from "./StaticPagesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports